import React, { Component } from "react";
import Link from '../Link/Link';
import { Container, Row, Col } from "react-bootstrap";
import AppConf from '../../Configuration/AppConfig';
class Footer extends Component {
  constructor() {
    super();
    this.state = {
      title: ""
    };
  }
  render() {
    return (
      <Container className='footer'>
        <Row>
          <i className='icon-logoSUEZ'></i>
          <i className='icon-logoCoDAI'></i>
          <Col sm={true}></Col>
          <div className='links'>
          {AppConf.Features.IsAppConsentEnabled === true &&
            <Link to={'/terms'}>Terms of service</Link>
          }
          </div>
        </Row>
      </Container>
    );
  }
}

export default Footer;
